<template>
    <div class="cents">
        <van-nav-bar
        :title="$t('txjl')"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
        />
        <!-- <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('mygd')"
            @load="onLoad"
        > -->
            <table border="1" frame="void"  cellspacing="0" style="width:100%;">
            <tr>
                <th>{{$t('txsj')}}</th>
                <th>{{$t('xm')}}</th>
                <th>{{$t('sbwz')}}</th>
                <th>{{$t('kmlx')}}</th>
            </tr>
            <tr v-for="(item,index) in list" :key="index">
                <td >{{item.open_time}}</td>
                <td>{{item.name}}</td>
                <td>{{ item.device_place}}</td>
                <td>{{item.open_type}}</td>
            </tr>
            
            </table>
        <!-- </van-list> -->
        <!-- <Footer :active="3" ref="footer"></Footer> -->
		<!-- 分页 -->
		<div class="data-load-more" v-if="deviceCount>30||Math.ceil(deviceCount/30)>1">
			<div @click="goTop">{{this.$t('syy')}}</div>
			<div style="width: 25px;" @click="pageTop" v-if="pageSizeList[0]!=1">...</div>
			<div class="pageSizeBox">
				<div v-for="(item,index) in pageSizeList" :key="item" style="width: 25px;" @click="handlePageSize(item)" :class="[page_index==item?'pageSizeItemState':'']">
					{{item>pageSize?'':item}}
				</div>
			</div>
			<div style="width: 25px;" @click="pageBottom" v-if="pageSize>pageSizeList[4]">...</div>
			<div @click="goBottom">{{this.$t('xyy')}}</div>
		</div>
    </div>
</template>

<script>
import {timestampToTime} from '@/utils/index.js'
export default {
    
    data(){
        return{
            loading:false,
            finished: false,
            active:3,
            list:[],
            Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
            page_index:1,
            count:null,
			deviceCount:0, // 接口返回设备数量
			pageSize:0, // 设备页数
			pageSizeList:[1,2,3,4,5], // 页码
        }
    },
    mounted(){
        this.list=[];
		this.getlist()
    },
    methods:{
        goto(){
            this.$router.go(-1)
        },
		// 页码点击
		handlePageSize(index){
			console.log(index,this.pageSize);
			console.log(this.page_index);
			 if(index>this.pageSize){
				return
			};
			this.page_index = index;
			this.getlist()
		},
		// 上个页码
		pageTop(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item-=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr;
		},
		// 下页码
		pageBottom(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item+=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr
		},
		// 上一页
		goTop(){
			if(this.deviceCount==0){
			  return
			};
			if(this.page_index==1){
			  this.$message.info(this.$t('ysdyy'))
			  return
			};
			this.page_index--;
			if(this.page_index<this.pageSizeList[0]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item-=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[4]
			}
			this.getlist()
		},
		// 下一页
		goBottom(){
			if(this.deviceCount==0){
			  return
			}
			if(this.page_index==this.pageSize){
			  this.$message.info(this.$t('mygd'))
			  return
			}
			this.page_index++;
			if(this.page_index>this.pageSizeList[4]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item+=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[0]
			}
			this.getlist()
		},
        onLoad() {
            this.page_index++;
            this.getlist()
        },
        getlist(){
            let data ={
                method:'co.wx.open.door.list',
                user_id:this.Userof.user_id,
                page_index:this.page_index,
                page_size:30
            }
            this.$serve(data).then(res=>{
                res.data.data.forEach(el=>{
                    el.open_time=timestampToTime(el.open_time*1000)
                    if(el.open_type==1){
                        el.open_type = this.$t('khkm')
                    }else if(el.open_type==2){
                        el.open_type = this.$t('yckm')
                    }else if(el.open_type==3){
                        el.open_type = this.$t('lykm')
                    }else if(el.open_type==4){
                        el.open_type = this.$t('mmkm')
                    }else if(el.open_type==5){
                        el.open_type = this.$t('zwkm')
                    }else if(el.open_type==6){
                        el.open_type = this.$t('rlkm')
                    }
                })
                this.loading = false;
                this.count = res.data.count
                if (res.data.data == [] || this.count.length === 0) {
                    // 加载结束
                    this.finished = true;
                    return;
                }
                // this.list = this.list.concat(res.data.data)
				this.list = res.data.data;
				this.deviceCount = res.data.count;
				this.pageSize = Math.ceil(res.data.count/10);
                
                if (this.list.length >= this.count) {
                    this.finished = true;
                }
            })
        }
    }
}
</script>

<style scoped>
td{border:solid #E2E2E2; border-width:0px 1px 1px 0px;}
table{border:solid #E2E2E2; border-width:1px 0px 0px 1px;}
th{
    height: 30px;
    background-color: #F2F2F2;
    font-size: 14px;
    font-weight: none
}
td{
    height: 30px;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
.data-load-more{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #eee;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	.pageSizeBox{
		width: 50%;
		display: flex;
		justify-content: space-around;
	}
	.pageSizeItem{
	  width: 50rpx;
	}
	.pageSizeItemState{
	  color: #ff2146;
	  text-decoration: underline;
	}
</style>